module.exports = __webpack_public_path__ + "assets/img/elem1-ability1.7dd30754.gif";